import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDBox, FDStack,
} from '@facet-wealth/design';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import useMobileLayout from 'Hooks/useMobileLayout';
import { DataValueMap } from 'Helpers/Testing';
import EstatePlanningProfileSubpageStepActionPicker from './EstatePlanningProfileSubpageStepActionPicker/EstatePlanningProfileSubpageStepActionPicker';
import EstatePlanningProfileSubpageStepNumber from './EstatePlanningProfileSubpageStepNumber/EstatePlanningProfileSubpageStepNumber';

const EstatePlanningProfileSubpageStep = ({
  resource,
}) => {
  const isMobile = useMobileLayout();
  const state = resource.attr('state');

  let titleColor = 'textPrimary';
  const subtitleColor = 'textPrimary';
  switch (state) {
    case 'complete':
      titleColor = 'disabled';
      break;
    case 'disabled':
      titleColor = 'primaryGray';
      break;
    default:
      break;
  }

  return (
    <FDBox
      width={'100%'}
      {...DataValueMap
        .init('estate-planning-step')
        .append(DataValueMap.keyMap.dataIndex, resource.attr('stepNumber'))
        .append(DataValueMap.keyMap.dataValue, state)
        .build()}
    >
      <FDStack direction={isMobile ? 'column' : 'row'} spacing={2} alignItems={isMobile ? undefined : 'center'}>
        <FDStack direction={'row'} alignItems={'center'} spacing={2}>
          <EstatePlanningProfileSubpageStepNumber resource={resource} />
          <FDBox>
            <Typography color={titleColor} variant={'h4'} weight={'bold'}>{resource.attr('title')}</Typography>
            {state === 'active' && (
              <FDBox paddingY={0.5}>
                <Typography color={subtitleColor} weight={'bold'}>{resource.attr('subtitle')}</Typography>
              </FDBox>
            )}
          </FDBox>
        </FDStack>
        <EstatePlanningProfileSubpageStepActionPicker resource={resource} />
      </FDStack>
    </FDBox>
  );
};

EstatePlanningProfileSubpageStep.defaultProps = {
};

EstatePlanningProfileSubpageStep.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default EstatePlanningProfileSubpageStep;
